import {
  Flex,
  Popover,
  Radio,
  Space,
  Button,
  Dropdown,
  Modal,
  message,
  Row,
  Col,
  Typography,
  Tag,
  Card,
  Checkbox,
} from "antd";
import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  MenuOutlined,
  EditOutlined,
  PlusOutlined,
  FileTextOutlined,
  DeleteOutlined,
  UploadOutlined,
  FormOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { dataTo12Fn } from "@/utils/date";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import AddModal from "./addModal";
import UploadModal from "./uploadModal";
import UploadToExcelModal from "./uploadExcelModal";
import UploadLiabilityModal from "./uploadLiabilityModal";
import "./index.css";

const InsurancePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const addModalRef = useRef(null);
  const UploadModalRef = useRef(null);
  const UploadToExcelModalRef = useRef(null);
  const uploadLiabilityModalRef = useRef(null);

  // // 从 URL 获取 foreignId
  // const getForeignId = () => {
  //   const params = new URLSearchParams(location.search);
  //   return params.get("id");
  // };

  const [currentRecord, setCurrentRecord] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [anetTypeOptions, setAnetTypeOptions] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [highlightRowId, setHighlightRowId] = useState(null);
  const [tableHead, setTableHead] = useState({
    expirationDate: null,
    effectiveDate: null,
    policyNumber: null,
    carrier: null,
    agent: null,
    payee: null,
    remark: null,
    openStatus: null,
  });


   const getUrlParams = () => {
    const params = new URLSearchParams(location.search);
    return {
      id: params.get("id"),
      summaryRecord: params.get("summaryRecord")
    };
  };
  const [summaryRecord, setSummaryRecord] = useState(null);


  // 初始化获取 foreignId
  // useEffect(() => {
  //   const id = getForeignId();
  //   if (id) {
  //     setCurrentRecord({ id });
  //     getTableListFn(1, 25, tableHead, { id });
  //   }
  // }, [location.search]);
   useEffect(() => {
    const { id, summaryRecord: encodedRecord } = getUrlParams();
    
    // 解析从 summary 传来的完整 record
    if (encodedRecord) {
      try {
        const parsedRecord = JSON.parse(decodeURIComponent(encodedRecord));
        setSummaryRecord(parsedRecord);
        setCurrentRecord(parsedRecord);
      } catch (e) {
        // console.error("解析 summaryRecord 失败", e);
        if (id) setCurrentRecord({ id });
      }
    } else if (id) {
      setCurrentRecord({ id });
    }
    
    if (id) {
      getTableListFn(1, 25, tableHead, { id });
    }
  }, [location.search]);

  const buildColumns = (checkedValues = selectedItems) =>
    initColumns.map((item) => ({
      ...item,
      hidden:
        checkedValues?.length > 0
          ? !checkedValues.includes(item.dataIndex)
          : false,
    }));

  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    setColumns(buildColumns(checkedValues));
  };

  const showModal = () => {
    // addModalRef.current?.setModelAdd(currentRecord);
    const recordToPass = summaryRecord || currentRecord;
    addModalRef.current?.setModelAdd(recordToPass);
  };

  const handleUpload = () => {
    UploadToExcelModalRef.current?.open({
      type: "transactions",
      record: currentRecord,
    });
  };

  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  const handleMenuClick = async (e, record) => {
    if (e.key === "EnterInsuranceList") {

     window.open(
    `/#/AccountPayable/InsuranceEnterPaymentPage?id=${record.id}`,
    "_blank",
  );
  return;
    }


  

    if (e.key === "UploadInsuranceList") {
      UploadModalRef.current?.open(record);
      return;
    }

    if (e.key === "DeleteInsuranceList") {
      Modal.confirm({
        title: "Confirm Delete",
        content: "Are you sure you want to delete this policy?",
        okText: "Delete",
        okType: "danger",
        cancelText: "Cancel",
        onOk: async () => {
          try {
            const res = await http.get(api.getInstanceDel, {
              params: { id: record?.id },
            });
            if (res?.code === "1") {
              message.success("Delete Successfully.");
              getTableListFn(
                pagination.current,
                pagination.pageSize,
                tableHead,
                currentRecord,
              );
            } else {
              message.error(res?.msg);
            }
          } catch (err) {
            message.error("Request Error");
          }
        },
      });
    }

    if (e.key === "EditDeductLimit") {
      uploadLiabilityModalRef.current?.open(record);
      return;
    }
  };

  const getAgentTypeList = async () => {
    try {
      const res = await http.get(api.getAgentType);
      const data = res?.data || res;
      const list = (data || []).map((item) => ({
        value: item.vendorId,
        label: item.vendorName,
      }));
      setAnetTypeOptions(list);
    } catch (err) {
      message.error("Request Error");
    }
  };

  const AnetTypeMap = useMemo(() => {
    const map = {};
    anetTypeOptions.forEach((item) => {
      map[item.value] = item.label;
    });
    return map;
  }, [anetTypeOptions]);

  const tableFilterFn = (event, key, type = "Input") => {
    if (type === "DatePicker") {
      setTableHead((prev) => {
        const updatedTableHead = {
          ...prev,
         [key]: event ? event.format("YYYY-MM-DD") : undefined,
        };
        getTableListFn(1, pagination.pageSize, updatedTableHead, currentRecord);
        return updatedTableHead;
      });
      return;
    }
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const paymentColumns = () => {
    return [0, 1, 2].map((item) => ({
      title: "Payment",
      dataIndex: `lastPayment_${item}`,
      width: 120,
      onCell: () => ({
        style: {
          padding: "8px",
        },
      }),
      render: (text, record) => {
        const { lastPayments } = record;
        const payment = (lastPayments || [])[item];
        if (!payment) return <div>-</div>;
        const { amount, paymentColor, paymentDate } = payment;
        const colorMatch = {
          0: "#3c8dbc",
          1: "#dd4b39",
          2: "green",
          3: "#f39c12",
        };
        const titleMatch = {
          0: "(Pending)",
          1: "(Not Cash)",
          2: "(Cashed)",
          3: "(Voided)",
        };

        const textColor = colorMatch[paymentColor] || "";
        const title = titleMatch?.[paymentColor] || "";

        return (
          <div style={{ color: textColor, cursor: "default" }}>
            {(title && (
              <span
                style={{
                  borderBottom: `1px dashed ${textColor}`,
                  paddingBottom: "2px",
                }}
              >
                {title}
              </span>
            )) ||
              null}
            <br />
            <span
              style={{
                borderBottom: `1px dashed ${textColor}`,
                paddingBottom: "2px",
              }}
            >
              {paymentDate ? moment(paymentDate).format("MM/DD/YYYY") : "-"}
            </span>
            <br />
            <span
              style={{
                borderBottom: `1px dashed ${textColor}`,
                paddingBottom: "2px",
              }}
            >
              {amount
                ? new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2,
                  }).format(parseFloat(amount))
                : "-"}
            </span>
          </div>
        );
      },
    }));
  };

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "bankId",
      hidden: false,
      align: "center",
      width: 80,
      render: (text, record) => {
        const menuItems = [
          commonFn.btnAuthorityFlag("EnterInsuranceList") && {
            key: "EnterInsuranceList",
            icon: <EditOutlined style={{ color: "#00c0ef", fontSize: 17 }} />,
            label: <div>Make Payment</div>,
          },
          //   commonFn.btnAuthorityFlag("EditInsuranceList") && {
          //     key: "EditInsuranceList",
          //     icon: <FileTextOutlined style={{ color: "#00c0ef", fontSize: 17 }} />,
          //     label: <div>Edit Policy</div>,
          //   },
          commonFn.btnAuthorityFlag("EditDeductLimitInsuranceList") &&
            record.isPayment && {
              key: "EditDeductLimit",
              icon: <FormOutlined style={{ color: "#00c0ef", fontSize: 17 }} />,
              label: <div>Edit Deduct&Limit</div>,
            },
          commonFn.btnAuthorityFlag("UploadInsuranceList") && {
            key: "UploadInsuranceList",
            icon: <UploadOutlined style={{ color: "#00c0ef", fontSize: 17 }} />,
            label: <div>Upload Policy</div>,
          },
          commonFn.btnAuthorityFlag("DeleteInsuranceList") && {
            key: "DeleteInsuranceList",
            icon: <DeleteOutlined style={{ color: "#ff4d4f", fontSize: 17 }} />,
            label: <div>Delete Policy</div>,
          },
        ].filter(Boolean);

        return (
          (menuItems.length > 0 && (
            <Dropdown
              menu={{
                items: menuItems,
                onClick: (e) => handleMenuClick(e, record),
              }}
              trigger={["click"]}
            >
              <MenuOutlined
                style={{ cursor: "pointer", fontSize: 16, color: "#0e78a9" }}
              />
            </Dropdown>
          )) ||
          null
        );
      },
    },
    {
      title: "Expiration Date",
      dataIndex: "expirationDate",
      titleType: "DatePicker",
      // onChange: (_, dateString) =>
      //   tableFilterFn(dateString, "expirationDate", "DatePicker"),
      onChange: (date) => tableFilterFn(date, "expirationDate", "DatePicker"),
      render: (value) => dataTo12Fn(value, 2),
    },
    {
      title: "Effective Date",
      dataIndex: "effectiveDate",
      titleType: "DatePicker",
      // onChange: (_, dateString) =>
      //   tableFilterFn(dateString, "effectiveDate", "DatePicker"),
       onChange: (date) => tableFilterFn(date, "effectiveDate", "DatePicker"),
      render: (value) => dataTo12Fn(value, 2),
    },
    {
      title: "Policy Number",
      dataIndex: "policyNumber",
      titleType: "Input",
      sortterMultiple: 2,
      onChange: (e) => tableFilterFn(e, "policyNumber"),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      width: 100,
      isAmountFlag: true,
    },
    {
      title: "# of Prop",
      dataIndex: "numberOfProperties",
      width: 100,
    },
    {
      title: "Carrier",
      dataIndex: "carrier",
      titleType: "Input",
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "carrier"),
    },
    {
      title: "Agent",
      dataIndex: "agent",
      titleType: "Select",
      sortterMultiple: 3,
      selectOptions: anetTypeOptions,
      onChange: (e) => tableFilterFn(e, "agent", "Select"),
    },
    ...paymentColumns(),
    {
      title: "Status",
      dataIndex: "openStatus",
      titleType: "Select",
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: [
        { label: "Open", value: "1" },
        { label: "Close", value: "0" },
      ],
      onChange: (e) => tableFilterFn(e, "openStatus", "Select"),
      render: (text, record) => {
        const { id } = record;
        const isOpen = Number(text) === 1;

        const handleClick = () => {
          let confirmLoading = false;
          const modalInstance = Modal.confirm({
            title: "Confirm Status Change",
            centered: true,
            content: (
              <div>
                <div style={{ textAlign: "center" }}>
                  Are you sure you want to change the status to
                  <span style={{ color: "#1890ff", fontWeight: 500 }}>
                    {isOpen ? " Close" : " Open"}
                  </span>
                  ?
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 12,
                    marginTop: 24,
                  }}
                >
                  <Button onClick={() => modalInstance.destroy()}>
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    loading={confirmLoading}
                    onClick={async () => {
                      if (confirmLoading) return;
                      confirmLoading = true;
                      modalInstance.update({
                        content: (
                          <div>
                            <div style={{ textAlign: "center" }}>
                              Are you sure you want to change the status to
                              <span
                                style={{ color: "#1890ff", fontWeight: 500 }}
                              >
                                {isOpen ? " Close" : " Open"}
                              </span>
                              ?
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                gap: 12,
                                marginTop: 24,
                              }}
                            >
                              <Button
                                onClick={() => modalInstance.destroy()}
                                disabled={true}
                              >
                                Cancel
                              </Button>
                              <Button
                                type="primary"
                                loading={true}
                                disabled={true}
                              >
                                Confirm
                              </Button>
                            </div>
                          </div>
                        ),
                      });
                      try {
                        const response = await http.get(
                          api.getInsuranceOpenStatus,
                          {
                            params: { id, openStatus: isOpen ? 0 : 1 },
                          },
                        );
                        if (response?.code === "1") {
                          message.success("Status updated successfully");
                          getTableListFn(
                            pagination.current,
                            pagination.pageSize,
                            tableHead,
                            currentRecord,
                          );
                        }
                      } catch (error) {
                        message.error("Status update failed");
                      } finally {
                        modalInstance.destroy();
                      }
                    }}
                  >
                    Confirm
                  </Button>
                </div>
              </div>
            ),
            footer: null,
          });
        };
        return (
          <Tag
            color={isOpen ? "green" : "red"}
            style={{ cursor: "pointer" }}
            onClick={handleClick}
          >
            {isOpen ? "Open" : "Close"}
          </Tag>
        );
      },
    },
  ];

  const getTableListFn = async (
    current,
    pageSize,
    tableHeadParams = {},
    foreignRecord = null,
  ) => {
    setTableLoading(true);
    const record = foreignRecord || currentRecord;
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...(record?.id && { foreignId: record.id }),
      ...tableHeadParams,
    };
    const response = await http.get(api.getInsuranceShow, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
      key: item.id,
    }));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (paginationProps, filters, sorter) => {
    const { field: orderField, order: orderType, columnKey } = sorter;
    if (columnKey === "trust") {
      const tableHeadTemp = {
        ...tableHead,
        orderField,
        orderType,
      };
      getTableListFn(
        paginationProps.current,
        paginationProps.pageSize,
        tableHeadTemp,
        currentRecord,
      );
    } else {
      getTableListFn(
        paginationProps.current,
        paginationProps.pageSize,
        tableHead,
        currentRecord,
      );
    }
  };

  const initColunmsFn = () => {
    setTableHead({
      expirationDate: null,
      effectiveDate: null,
      policyNumber: null,
      carrier: null,
      agent: null,
      payee: null,
      remark: null,
      openStatus: null,
    });
    const transformedList = initColumns
      .map((item) => ({
        label: item.title,
        value: item.dataIndex,
      }))
      .filter((item) => item.value);
    setOptions(transformedList);
    const transformedList2 = initColumns
      .map((item) => item.dataIndex)
      .filter(Boolean);
    setSelectedItems(transformedList2);
    setColumns(buildColumns(transformedList2));
  };

  useEffect(() => {
    initColunmsFn();
    getAgentTypeList();
  }, []);

  useEffect(() => {
    setColumns(buildColumns(selectedItems));
  }, [anetTypeOptions, selectedItems]);

  // 监听跨窗口消息刷新
  useEffect(() => {
    const handler = (event) => {
      if (event.data?.type === "INSURANCE_REFRESH") {
        getTableListFn(
          pagination.current,
          pagination.pageSize,
          tableHead,
          currentRecord,
        );

        // summary 刷新
        if (window.opener && !window.opener.closed) {
          window.opener.postMessage(
            { type: "INSURANCE_REFRESH", id: event.data?.id },
            "*",
          );
        }
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [pagination.current, pagination.pageSize, tableHead, currentRecord]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <Space>
          {commonFn.btnAuthorityFlag("NewInsuranceList") && (
            <Button className="btnNew" onClick={showModal}>
              <PlusOutlined />
              New
            </Button>
          )}
          {commonFn.btnAuthorityFlag("UploadExcelInsuranceList") && (
            <Button onClick={handleUpload} className="btnNew">
              <UploadOutlined />
              Upload
            </Button>
          )}
        </Space>
        <div className="min-width">
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={() => setRefreshKey(+new Date())}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableCss="maintenanceTable"
        rowKey="id"
        rowClassName={(record) =>
          record.id === highlightRowId ? "highlight-row" : ""
        }
      />

      {/* Modals */}
      <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn(
            pagination.current,
            pagination.pageSize,
            tableHead,
            currentRecord,
          );
        }}
      />
      <UploadModal
        ref={UploadModalRef}
        onSuccess={() => {
          getTableListFn(
            pagination.current,
            pagination.pageSize,
            tableHead,
            currentRecord,
          );
        }}
      />
      <UploadToExcelModal
        ref={UploadToExcelModalRef}
        onSuccess={() => {
          getTableListFn(
            pagination.current,
            pagination.pageSize,
            tableHead,
            currentRecord,
          );
        }}
      />
      <UploadLiabilityModal
        ref={uploadLiabilityModalRef}
        onSuccess={() => {
          getTableListFn(
            pagination.current,
            pagination.pageSize,
            tableHead,
            currentRecord,
          );
        }}
      />
    </div>
  );
};

export default InsurancePage;
